import { render, staticRenderFns } from "./SiteMake.vue?vue&type=template&id=2442eae2&scoped=true&"
import script from "./SiteMake.vue?vue&type=script&lang=js&"
export * from "./SiteMake.vue?vue&type=script&lang=js&"
import style0 from "./SiteMake.vue?vue&type=style&index=0&id=2442eae2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442eae2",
  null
  
)

export default component.exports